import uploadsservicesexpungementimageshutterstock_1817118887500x282Jpg from "$lib/data/generated/uploads/services/Expungement/image/shutterstock_1817118887 500x282.jpg";

export const uploads = {
  "uploads/services/Expungement/image/shutterstock_1817118887 500x282.jpg": uploadsservicesexpungementimageshutterstock_1817118887500x282Jpg
};